import {
  isContinuousWaveParcel,
  nonCadScannedParcel,
} from "../../../models/parcel";

export const NON_CADS_OPTION = {
  value: "nonCads",
  label: "Move non-CADS",
  condition: nonCadScannedParcel,
};

export const CONTINUOUS_WAVE_OPTION = {
  value: "continuousWave",
  label: "Continuous Wave",
  condition: isContinuousWaveParcel,
};

export const REMOVE_OPTIONS_LIST = [NON_CADS_OPTION, CONTINUOUS_WAVE_OPTION];
